module.exports = ".required {\r\n  content:\"*\";\r\n  color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/recurrence/recurrent-orderitem-form.component.css
// module id = ./src/app/recurrence/recurrent-orderitem-form.component.css
// module chunks = main